function ChangeMenuLink (vehicle_id) {
      document.querySelectorAll(".category-item__wrapper").forEach((menu) => {
          let tag = menu.getAttribute("menu-tag");

          // console.log(vehicle_id);
        
          if (tag == '') {
          }
        
          else if (vehicle_id != "0") {
            let old_href = menu.getAttribute("href");
            
            menu.setAttribute("data-href", old_href);
            menu.setAttribute("href", `/collections/${vehicle_id}/${tag}`);
            
          } else {
            let old_href = menu.getAttribute("data-href");
            
            menu.setAttribute("href", old_href);
            menu.removeAttribute("data-href");
          }
    });
}